
const HelperText = ({ text, color = "#bbbbbb" }) => {
    return (
        <span style={{ color: color, fontSize: ".7rem", padding: "2px 10px", height: "0px", position: "relative" }}>
            {text}
        </span>
    )
}

export { HelperText }